// extracted by mini-css-extract-plugin
export default {"wrapper":"BasicLayout_wrapper__0qx7k","header":"BasicLayout_header__fT+nC","content-wrapper":"BasicLayout_content-wrapper__EzbPt"};